import React from 'react';
export const FooterSection = () => {
  return <footer className="bg-biosync-darkBg py-10 px-5 sm:px-10 text-center" data-id="element-108">
      <div className="max-w-[1100px] mx-auto" data-id="element-109">
        <div className="mb-8" data-id="element-110">
          <div className="text-white font-bold text-2xl tracking-wider mb-2" data-id="element-111">
            ⚡ BIO-SYNC™
          </div>
          <div className="text-white/80 italic" data-id="element-112">
            "El Código de Regulación Emocional"
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-12 text-white/90 text-sm" data-id="element-113">
          <a href="#" className="hover:text-biosync transition-colors" data-id="element-114">
            📧 soporte.biosync@gmail.com
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-115">|</span>
          <a href="#" className="hover:text-biosync transition-colors" data-id="element-116">
            📲 @biosync.oficial
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-117">|</span>
          <a href="#" className="hover:text-biosync transition-colors" data-id="element-118">
            🌐 www.biosync.online
          </a>
        </div>

        <div className="text-white/40 text-xs max-w-2xl mx-auto leading-relaxed space-y-4" data-id="element-119">
          <p data-id="element-120">
            © BIO-SYNC™ 2025 — Todos los derechos reservados.
            <br data-id="element-121" />
            Prohibida la reproducción sin autorización expresa.
          </p>
          <p data-id="element-122">
            BIO-SYNC™ es un producto digital de desarrollo emocional.
            <br data-id="element-123" />
            No reemplaza la atención psicológica profesional.
          </p>
        </div>
      </div>
    </footer>;
};